import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { clearBank, getBank, putBank } from '../../../../actions';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import { BANK_PATH } from '../../../../config/paths';
import BankForm from './BankForm';

const EditBank = ({
  breadcrumbs,
  dispatchGetBank,
  dispatchClearBank,
  dispatchPutBank,
  match: {
    params: { id: bankId },
  },
  loading,
  bank,
}) => {
  useLayoutEffect(() => {
    dispatchGetBank({ bankId });

    return () => dispatchClearBank();
  }, []);

  const onSubmit = (formValues) =>
    dispatchPutBank(bankId, {
      ...formValues,
      countryId: formValues.countryId.id,
    });

  const generateInitialValues = ({ name, swiftCode, country }) => ({
    name,
    swiftCode,
    countryId: {
      value: country.countryCode,
      label: country.name,
      id: country.id,
    },
  });

  let content;

  if (loading) content = <Loader />;
  else if (bank.isEmpty()) content = <NoDataResource returnPage={BANK_PATH} />;
  else
    content = (
      <BankForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(bank.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Banco"
      subtitle="Editar banco"
      content={content}
    />
  );
};

EditBank.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearBank: PropTypes.func.isRequired,
  dispatchGetBank: PropTypes.func.isRequired,
  dispatchPutBank: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  bank: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditBank.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearBank: clearBank,
  dispatchGetBank: getBank,
  dispatchPutBank: putBank,
};

const mapStateToProps = (
  { AccountingUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Bancos',
      href: BANK_PATH,
    },
    {
      text: 'Ver',
      href: `${BANK_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  bank: AccountingUnit.Bank.getIn(['current', 'content']),
  loading: !AccountingUnit.Bank.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditBank);
